import React, {useCallback, useState} from "react";
import {Modal, ConfigProvider, message} from "antd";
import DeliveryProviderInvoiceTable from "../DeliveryProviderInvoiceTable/DeliveryProviderInvoiceTable";
import {useRequest} from "../../../utils/hooks";
import {SquareButton} from "../../../components";
import {InvoiceStatusTypes} from "../../../provider/ProviderManageInvoices/consts";
import {DeclineInvoiceModal} from "../../AdminInvoices/DeclineInvoiceModal";
import {DeliveryProviderDeliveriesProjection} from "../../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts";
import {HttpClient} from "../../../http/HttpClient";
import {NOOP} from "../../../utils/NOOP.jsx";

const AdminDeliveryProviderInvoiceModal = ({visible, onCancel, invoice, updateStatus, onRemove = NOOP}) => {
    const [showDeclineModal, setShowDeclineModal] = useState(false);

    const deleteInvoice = useCallback(
        async (invoiceId, invoiceDeliveryProviderId) => {
            const {error} = await HttpClient.safeDelete(
                `/admin/api/deliveryProviderInvoice/${invoiceDeliveryProviderId}/${invoiceId}`
            );

            if (error) {
                message.error("שגיאה בעת מחיקת חשבונית");
                return;
            }

            message.success("חשבונית נמחקה בהצלחה");

            onRemove();
        },
        [onRemove]
    );

    const [deliveriesResponse, loadingDeliveries] = useRequest(
        "/admin/api/deliveries/byIds",
        "POST",
        {
            deliveryIds: invoice?.deliveries,
            projection: DeliveryProviderDeliveriesProjection
        },
        [invoice?.deliveries],
        !!invoice?.deliveries?.length
    );

    return (
        <ConfigProvider direction="rtl">
            <>
                <DeclineInvoiceModal
                    visible={showDeclineModal}
                    onClose={() => setShowDeclineModal(false)}
                    onSave={async values => {
                        await updateStatus(InvoiceStatusTypes.DECLINED, values.declineMessage);
                        setShowDeclineModal(false);
                    }}
                />

                <Modal
                    className="admin-delivery-provider-invoice-modal"
                    width="90vw"
                    destroyOnClose={true}
                    open={visible}
                    onCancel={onCancel}
                    footer={null}
                    title={null}>
                    <DeliveryProviderInvoiceTable
                        deliveries={deliveriesResponse || []}
                        loadingDeliveries={loadingDeliveries}
                        selectedMonth={null}
                        invoices={[invoice]}
                        shouldSelectInvoicedDeliveries={true}
                        deleteInvoice={deleteInvoice}
                    />
                    <div className="admin-invoice-provider-invoice-modal-buttons">
                        <SquareButton className="decline-color-button" onClick={() => setShowDeclineModal(true)}>
                            דחה חשבונית
                        </SquareButton>
                        <SquareButton
                            className="accept-color-button"
                            onClick={() => updateStatus(InvoiceStatusTypes.ACCEPTED)}>
                            אשר חשבונית
                        </SquareButton>
                    </div>
                </Modal>
            </>
        </ConfigProvider>
    );
};

export default AdminDeliveryProviderInvoiceModal;
